export default __webpack_public_path__ + "static/footer-3f5ca31c70faab92518e9937f4306675.png";